<res-base-modal
    [modalTitle]="'Copy to Document Storage'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId" 
    [primaryButtonLabel]="'Copy'" (primaryButtonActionEmt)="copyToDocStorage()" (closeButtonActionEmt)="closeModal()" 
    [isPrimaryBtnEnabled]="!isBusy && corpus"
    [secondaryButtonLabel]="'Cancel'"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" 
    [modalHelpIndex]="modalHelpIndex">

    <div class="modal-row">
        <div class="modal-row-column-auto">Options:</div>
        <div class="modal-row-column-auto optionsList">
            <res-custom-checkbox automationId="copy-doc-storage-disk-image" [(ngModel)]="exclusions.DOCCLASS_DISKIMAGE" content="Exclude Document Class: Disk Image"></res-custom-checkbox>
            <res-custom-checkbox automationId="copy-doc-storage-archive-image" [(ngModel)]="exclusions.DOCCLASS_ARCHIVE" content="Exclude Document Class: Archive"></res-custom-checkbox>
            <res-custom-checkbox automationId="copy-doc-storage-message-archive-image" [(ngModel)]="exclusions.DOCCLASS_MAIL_CONTAINER" content="Exclude Document Class: Message Archive"></res-custom-checkbox>
            <res-custom-checkbox automationId="copy-doc-storage-nist-edoc-image" [(ngModel)]="exclusions.NIST_EDOC" content="Exclude NIST EDoc"></res-custom-checkbox>
        </div>
    </div>
</res-base-modal>   